import { useContext } from 'react';
import i18nContext from 'components/i18n-context';
import './AmlNotesTabHeadRow.scss';

export const AML_NOTES_TAB_TABLE_HEADER = [
  {
    label: 'authorAndDate',
    width: '17.5%'
  },
  {
    label: 'assignee',
    width: '17.5%'
  },
  {
    label: 'note',
    width: '65%'
  }
];

export const AmlNotesTabHeadRow = () => {
  const i18n = useContext(i18nContext);

  return (
    <tr>
      {AML_NOTES_TAB_TABLE_HEADER.map((head) => (
        <th key={head.label} className={'aml-notes-table-head'} width={head.width}>
          <div className={'aml-notes-table-head-block'}>
            <span>{i18n.getMessage(`amlNotes.table.header.${head.label}`)}</span>
          </div>
        </th>
      ))}
    </tr>
  );
};
